/**
 * Event View
 */
export const K_AMPLITUDE_EVENT_VIEW_HOME_PAGE = 'Page View: Home Page'; // ✅
export const K_AMPLITUDE_EVENT_VIEW_ABOUT = 'Page View: About'; // ✅
export const K_AMPLITUDE_EVENT_VIEW_SIGN_IN_PAGE = 'Page View: Sign In Page';
export const K_AMPLITUDE_EVENT_VIEW_SIGN_UP_COMPANY_PAGE = 'Page View: Sign Up Page | Company'; // ✅
export const K_AMPLITUDE_EVENT_VIEW_SIGN_UP_INDIVIDUAL_STEP_1_PAGE =
  'Page View: Sign Up Page | Individual | Step 1'; // ✅
export const K_AMPLITUDE_EVENT_VIEW_SIGN_UP_INDIVIDUAL_COMPLETION_PAGE =
  'Page View: Sign Up Page | Individual | Completion'; // ✅
export const K_AMPLITUDE_EVENT_VIEW_DASHBOARD_PAGE = 'Page View: Dashboard'; // ✅
export const K_AMPLITUDE_EVENT_VIEW_PURCHASE_FORM_PAGE = 'Page View: Purchase Form Page'; // ✅
export const K_AMPLITUDE_EVENT_VIEW_REDEEM_FORM_PAGE = 'Page View: Redeem Form Page'; // ✅
export const K_AMPLITUDE_EVENT_VIEW_SWAP_FORM_PAGE = 'Page View: Swap Form Page'; // ✅
export const K_AMPLITUDE_EVENT_VIEW_BLOG_LANDING_PAGE = 'Page View: Blog Landing Page'; // ✅
export const K_AMPLITUDE_EVENT_VIEW_BLOG_DETAIL_PAGE = 'Page View: Blog Detail Page'; // ✅
export const K_AMPLITUDE_EVENT_VIEW_TRANSACTION_DETAIL_PAGE = 'Page View: Transaction Detail Page'; // ✅
export const K_AMPLITUDE_EVENT_VIEW_MINIGAMES_LANDING_PAGE = 'Page View: Minigames Landing Page'; // ✅
export const K_AMPLITUDE_EVENT_VIEW_MINIGAMES_LEADERBOARD_PAGE =
  'Page View: Minigames Leaderboard Page'; // ✅
export const K_AMPLITUDE_EVENT_VIEW_CAREER_PAGE = 'Page View: Career Page';
export const K_AMPLITUDE_EVENT_VIEW_CAREER_DETAIL_PAGE = 'Page View: Career Detail Page';

export const K_AMPLITUDE_EVENT_CLICK_WHITEPAPER = 'Click: Whitepaper';
export const K_AMPLITUDE_EVENT_CLICK_LOGIN_VIA_GMAIL = 'Click: Login via Gmail';

/**
 * Components Event
 */
export const K_AMPLITUDE_EVENT_BUTTON_CLICK = 'Button Click'; // ✅ -- in basic/Button.tsx
export const K_AMPLITUDE_EVENT_FILE_UPLOAD_BEGIN = 'File Upload: Begin'; // ✅ -- in form/UploadFile.tsx
export const K_AMPLITUDE_EVENT_FILE_UPLOAD_END = 'File Upload: End'; // ✅ -- in form/UploadFile.tsx
export const K_AMPLITUDE_EVENT_FILE_UPLOAD_ERROR = 'File Upload: Error'; // ✅ -- in form/UploadFile.tsx

export const K_AMPLITUDE_EVENT_OPEN_QR_ADDRESS_CODE_SCANNER = 'Open Address QR Code Scanner';

/**
 * Registration Completion
 */
export const K_AMPLITUDE_EVENT_FORM_SIGN_UP_INDIVIDUAL_COMPLETE =
  'Form: Sign Up | Individual | Complete';

/**
 * REVENUE
 */
export const K_AMPLITUDE_REVENUE_EVENT_TYPE_PURCHASE = 'PURCHASE';
export const K_AMPLITUDE_REVENUE_EVENT_TYPE_REDEEM = 'REDEEM';
export const K_AMPLITUDE_REVENUE_EVENT_TYPE_SWAP = 'SWAP';

/**
 * AB Testing
 */
export const K_AMPLITUDE_AB_TEST_USER_DASHBOARD_VARIANT_FULL_VIEW =
  'AB Test: User Dashboard - Full | View';
export const K_AMPLITUDE_AB_TEST_USER_DASHBOARD_VARIANT_SIMPLE_VIEW =
  'AB Test: User Dashboard - Simple | View';
